import "./vyneDescriptions.scss";
import { Descriptions, type GetProps } from "antd";

type DescriptionsProps = GetProps<typeof Descriptions>;

interface VyneDescriptionsProps extends Readonly<DescriptionsProps> {
    /* Whether to display in card format */
    readonly inCard?: boolean;
}

/** Override for the AntD {@link Descriptions} component that applies common Vyne styles and ensures compatibility. */
export const VyneDescriptions = ({ className, inCard, ...props }: Readonly<VyneDescriptionsProps>) => (
    <Descriptions
        {...props}
        className={`vyne-descriptions ${inCard === true ? "vyne-descriptions-card" : ""} ${className ?? ""}`}
    />
);
